export const getById = (id: string) => ({
  className: 'Retailer',
  include: 'account',
  where: {
    objectId: id,
  },
});

const RetailerQueries = {
  getById,
};

export default RetailerQueries;
